var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('h3',{staticClass:"tit yo"},[_vm._v(_vm._s(_vm.textos[_vm.idioma].algomassobre))]),_c('div',{staticClass:"row"},[_c('p',{staticClass:"bigparr yo"},[_vm._v(_vm._s(_vm.textos[_vm.idioma].soydelosque))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }